/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { TalkoFactory, TalkoFactoryInterface } from "../TalkoFactory";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_shareableTokenBeacon_vLogic",
        type: "address",
      },
      {
        internalType: "address",
        name: "_likeTokenBeacon_vLogic",
        type: "address",
      },
      {
        internalType: "address",
        name: "_endorseTokenBeacon_vLogic",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_eproxy",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
    ],
    name: "EndorseERC721ProxyCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_lproxy",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
    ],
    name: "LikeERC721ProxyCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_sproxy",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
    ],
    name: "ShareableERC721ProxyCreated",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "EndorseERC721BeaconAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "LikeERC721BeaconAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OPERATOR_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ShareableERC721BeaconAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "addAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOperater",
        type: "address",
      },
    ],
    name: "addOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
    ],
    name: "createEndorseERC721Proxy",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
    ],
    name: "createLikeERC721Proxy",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
    ],
    name: "createShareableERC721Proxy",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
    ],
    name: "endorsableProxyNameExists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getIndexForEndorseERC721ProxyInstance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getIndexForLikeERC721ProxyInstance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getIndexForShareableERC721ProxyInstance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
    ],
    name: "likeableProxyNameExists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    name: "removeAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "removeOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
    ],
    name: "shareableProxyNameExists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type TalkoFactoryConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TalkoFactoryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TalkoFactory__factory extends ContractFactory {
  constructor(...args: TalkoFactoryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "TalkoFactory";
  }

  deploy(
    _shareableTokenBeacon_vLogic: string,
    _likeTokenBeacon_vLogic: string,
    _endorseTokenBeacon_vLogic: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TalkoFactory> {
    return super.deploy(
      _shareableTokenBeacon_vLogic,
      _likeTokenBeacon_vLogic,
      _endorseTokenBeacon_vLogic,
      overrides || {}
    ) as Promise<TalkoFactory>;
  }
  getDeployTransaction(
    _shareableTokenBeacon_vLogic: string,
    _likeTokenBeacon_vLogic: string,
    _endorseTokenBeacon_vLogic: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _shareableTokenBeacon_vLogic,
      _likeTokenBeacon_vLogic,
      _endorseTokenBeacon_vLogic,
      overrides || {}
    );
  }
  attach(address: string): TalkoFactory {
    return super.attach(address) as TalkoFactory;
  }
  connect(signer: Signer): TalkoFactory__factory {
    return super.connect(signer) as TalkoFactory__factory;
  }
  static readonly contractName: "TalkoFactory";
  public readonly contractName: "TalkoFactory";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TalkoFactoryInterface {
    return new utils.Interface(_abi) as TalkoFactoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TalkoFactory {
    return new Contract(address, _abi, signerOrProvider) as TalkoFactory;
  }
}
